/**
 * A one-line data-freshness indicator for the salience tiles.
 *
 * The dashboard header says "scored 2h ago" — but that only means the scorer
 * ran, not that the underlying collection is current (a throttled DOC API or a
 * starved classifier can leave an agenda's line days-to-weeks stale under a
 * fresh-looking header; see the 2026-07-03 viz review §2). This surfaces the
 * series' actual latest bucket as provenance, and flips to an amber "Stale"
 * badge when that bucket is older than the agenda's cadence (AGENDA_STALE_DAYS).
 */
import { isStale, shortDate } from "./format";

export function Freshness({
  agenda,
  date,
  className = "",
}: {
  agenda: string;
  date: string | null | undefined;
  className?: string;
}) {
  if (!date) return null;
  const stale = isStale(agenda, date);
  return (
    <div
      className={`flex items-center gap-1.5 text-[10px] ${className}`}
      title={`Latest data point: ${shortDate(date)}`}
    >
      {stale && (
        <span className="inline-flex items-center gap-1 rounded bg-[#f5a524]/15 px-1.5 py-0.5 font-semibold uppercase tracking-wider text-[#f5a524]">
          <span className="h-1.5 w-1.5 rounded-full bg-[#f5a524]" aria-hidden />
          Stale
        </span>
      )}
      <span className={stale ? "text-[#f5a524]/90" : "text-terminal-ink-muted/70"}>
        through {shortDate(date)}
      </span>
    </div>
  );
}
